import React from "react";
import ContactForm from "../ContactForm";
import Navbar from "../../components/Navbar";
function Contact() {
  return (
    <div>
      <Navbar />
      <ContactForm />
    </div>
  );
}

export default Contact;
